import { useContext } from 'react';
import { StoresContext } from './StoresContext';

/**
 * Hook replacement for the legacy `withStores` HOC.
 * Returns the full stores object as provided by <StoresProvider value={stores}>.
 */
export function useStores() {
  const stores = useContext(StoresContext);
  if (!stores) {
    throw new Error(
      'StoresContext is missing. Wrap your app in <StoresProvider value={stores}>.'
    );
  }
  return stores;
}
